import { useMemo } from 'react';
import { buildSentimentBreakdown } from '../utils/buildSentimentBreakdown';
import { useThemeMentions } from './useThemeMentions';

export const usePulseSentimentBreakdown = ({
  themeId,
}: {
  themeId: string;
}) => {
  const { data, isLoading, isError } = useThemeMentions({ themeId });

  return {
    data: useMemo(
      () => (data ? buildSentimentBreakdown(data.mentions) : undefined),
      [data]
    ),
    isLoading,
    isError,
  };
};
